import React, { useMemo, useState,  } from 'react';
import { shallowEqual, history, useSelector } from 'umi';
import { Modal } from 'tea-component';
import DragDrop from '@/pages/datalab/assets/svg/workBench/dragDrop.svg';
import ExploratoryAnalysis from '@/pages/datalab/assets/svg/workBench/exploratoryAnalysis.svg';
import DragDropA from '@/pages/datalab/assets/svg/workBench/dragDrop-action.svg';
import ExploratoryAnalysisA from '@/pages/datalab/assets/svg/workBench/exploratoryAnalysis-action.svg';
import './index.scss';
import { SYSTEM_NAME } from '@dbl/core/global';
import { useDblIntl } from '@/pages/datalab/utils/utils';

const CreateChart = (props: any) => {
  const { visible, handleOnSubmit, close } = props;
  const { dblFormatMessage, createDblFormatMessage, isEn } = useDblIntl("myAnalysis");
  const dblFormatMessageMulti = createDblFormatMessage('multi');
  const {gameCode, exploreGame} = useSelector((state: any) => ({
    exploreGame: state.exploreAnalysisGames.exploreGame,
    gameCode: state.datalab.gameCode,
  }), shallowEqual);
  
  const textList = useMemo(() => {
    const list = [
      {
        id: 'Drag & Drop Analysis',
        img: DragDrop,
        text: dblFormatMessageMulti('title'),
        action: DragDropA
      }
    ];
    if (exploreGame.includes(gameCode))
      list.push({
        id: 'Exploratory Analysis',
        img: ExploratoryAnalysis,
        text: dblFormatMessage('exploratory_analysis'),
        action: ExploratoryAnalysisA,
      });
    return list;
  }, [isEn, exploreGame, gameCode]);
  
  return (
    <Modal
      className="dbl-create-chart"
      visible={visible}
      caption={dblFormatMessage('new')}
      onClose={close}
      size={exploreGame.includes(gameCode) ? 500 : 260}
    >
      <Modal.Body>
        <div className="dbl-create-chart-box">
          {textList.map((item: any, index: number) => (
            <ItemBox
              key={index}
              item={item}
              handleOnSubmit={handleOnSubmit}
              gameCode={gameCode}
            />
          ))}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CreateChart;

const ItemBox = (props: any) => {
  const { item, handleOnSubmit, gameCode = '' } = props || {};
  const [hover, setHover] = useState(false);
  
  const jumpToAddChart = (id: string) => {
    const path = id === 'Drag & Drop Analysis' ? `/${SYSTEM_NAME}/${gameCode}/Analysis/MultiAnalysis?from=add` : `/${SYSTEM_NAME}/${gameCode}/Action/ExploreAnalysis?from=add`;
    if (handleOnSubmit) {
      handleOnSubmit(path);
      return;
    }
    history.push(path);
  };
  return (
    <div
      className="dbl-create-chart-item"
      onClick={() => jumpToAddChart(item?.id)}
      onMouseMove={() => setHover(true)}
      onMouseOut={() => setHover(false)}
    >
      <img
        src={hover ? item.action : item.img}
        className="dbl-create-chart-img"
      />
      <div className="dbl-create-chart-text">{item.text}</div>
    </div>
  );
};
